import React, { 
    useState, 
    useEffect  
  } from 'react'
  
  import Navbar from '../../Components/Navbar/Navbar'
  import toast from 'react-hot-toast';

  import { 
      Layout,
      Col, 
      Row,
      Button,
      Space,
      Modal,
      Form,
      Input,
      Table,
      Select,
  } from 'antd';
  import { 
    ProductOutlined 
  } from '@ant-design/icons';
  import { UseGetRequest } from '../../Utils/api/ApiRequests' 
  import { usePostRequest } from '../../hooks/usePostRequest'
  import { useNavigate, useLocation } from "react-router-dom"
  import { StatusOptions } from '../../Utils/api/DropdownfilterApi';
  
  const { Item } = Form;
  const { Search } = Input;
  const { TextArea } = Input;
  
  const Corporate = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [statusForm] = Form.useForm();
    const [isLoading, setIsLoading] = useState(false);
    const [corporateModal, setCorporateModal] = useState(location.state ? true : false);
    const [corporateData, setCorporateData] = useState([]);
    const [statusFilter, setStatusFilter] = useState('');
    const [filterConfig, setFilterConfig] = useState({member_id: '',term: '',})
    const { callPost, loading } = usePostRequest(()=>{
        statusForm.resetFields();
        setCorporateModal(false);
        fetchCorporateData();
    });
  
    const customSpinner = <ProductOutlined style={{ fontSize: 24, color: "#005E30"  }} spin />;

    const columns = [
        {
            title: 'Corporate ID',
            dataIndex: 'corporate_no',
            key: 'corporate_no',
            width:'15%',
            sorter: (a, b) => a.corporate_no.localeCompare(b.corporate_no),
        },
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            width:'35%',
            sorter: (a, b) => a.name.localeCompare(b.name),
        
        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
            width:'35%',
            sorter: (a, b) => a.email.localeCompare(b.email),
        
        },
        {
            title: "Status",
            dataIndex: "status",
            key: "status",
            width: "15%",
            render: (status) => status,
            sorter: (a, b) => (a.status || "").localeCompare(b.status || ""),
        },
    ];
  
    async function fetchCorporateData() {
      setIsLoading(true);
      const response = await UseGetRequest("corporates/get_member_corporate", filterConfig);
      if (response?.data) {
        setCorporateData(response?.data?.member_corporates);
      } else {
        setCorporateData([]);
      }
      setIsLoading(false);
    }

    const handleAddCorporate = () => {
        statusForm.validateFields().then(values => {
            const newValues = {
                corporate_no: values.corporate_no || ' ',
                name: values.name || ' ',
                address_1: values.address_1 || ' ',
                address_2: values.address_2 || ' ',
                fax: values.fax || ' ',
                telephone: values.telephone || ' ',
                certificate_no: values.certificate_no || ' ',
                email: values.email || ' ',
                nature_of_business: values.nature_of_business || ' ',
            }

            callPost(
                "corporates/create_corporate", 
                newValues,
                false,
            );
        }).catch(errorInfo => { 
          toast.error('Validation Failed ', errorInfo);
        });
    };

    const handleTableChange = (pagination) => {
      setFilterConfig((prev) => ({
        ...prev,
        page: parseInt(pagination.current),
        page_size: pagination.pageSize,
      }));
    };

    const handleChange = (e) => {
        setFilterConfig((prev) => (
          {
            ...prev,
            term: e || '',
            page: 1,
          }
        ));
    };
      
    const handleEmpty = (e) => {
        if(e.target.value === ''){
          setFilterConfig((prev) => (
            {
              ...prev,
              term: e.target.value || '',
              page: 1,
            }
          ));
        }
    };
    
    useEffect(() => {
        if (!corporateModal) {
          window.history.replaceState({}, document.title, location.pathname);          
          setCorporateModal(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [corporateModal]);

      
    useEffect(() => {
        fetchCorporateData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filterConfig]);

    const filteredCorporateData = statusFilter
        ? corporateData.filter((row) => row.status === statusFilter)
        : corporateData;
    return (
        <Layout className='page'>
            <Navbar navKey={'corporate'}/>
            <Layout className='content-container overflow-y'>
                <Row className='custom-padding responsive-tab-inline'>
                    <Col span={15} className='header-container'>
                        CORPORATE
                    </Col>
                    <Col span={9} className='mt-2 responsive-tab-width' align='end'>
                        <Space className='responsive-inline'> 
                            <Search
                                placeholder="Search Corporate"
                                size='medium'
                                onSearch={(e)=>handleChange(e)}
                                onChange={(e)=>handleEmpty(e)}
                                className='responsive-header-input'
                            />        
                            <Button 
                                className='button-color responsive-header-btn' 
                                onClick={() => setCorporateModal(true)} 
                                type="primary"
                            >
                                Add Corporate
                            </Button>         
                        </Space>
                    </Col>
                </Row>
                <Row className='mb-4 member-status-filter-row'>
                    <Space className='responsive-inline'>
                        <Select
                            placeholder="Select Status"
                            aria-label="Filter corporates by status"
                            value={statusFilter || undefined}
                            onChange={(status) => setStatusFilter(status || '')}
                            allowClear
                            placement="bottomLeft"
                            className="select-field responsive-header-input"
                            options={StatusOptions()}
                        />
                    </Space>
                </Row>
                <Row className='page-content'>
                    <Col span={24} className='responsive-overflow-auto'>
                        <Table 
                            columns={columns} 
                            dataSource={filteredCorporateData}
                            loading={{
                            indicator: customSpinner,
                            spinning: isLoading,
                            }}
                            pagination={{
                            defaultPageSize: 10,
                            //   total: pageSize,
                            current: filterConfig?.page,
                            pageSize: filterConfig?.total_records_per_page,
                            }}
                            onChange={handleTableChange}
                            onRow={(record, rowIndex) => {
                                return {
                                  className: 'cursor',
                                  onClick: () => navigate('/corporate/profile/' + record.id),
                                };
                            }}
                        />
                    </Col>
                </Row>
                <Modal
                    title="Add Corporate"
                    open={corporateModal}
                    onOk={handleAddCorporate}
                    onCancel={() => setCorporateModal(false)}
                    okText="Save"
                    maskClosable={false}
                    width={800} 
                    loading={loading}
                >
                    <Form 
                        form={statusForm} 
                        layout="vertical"
                    >
                        <Row>
                            <Col span={12} className='p-2'>
                                <Item
                                    label="Corporate ID"
                                    name="corporate_no"
                                    rules={[{ required: true, message: 'Please select a Corporate ID' }]}

                                >
                                    <Input/>
                                </Item>
                            </Col>
                            <Col span={12} className='p-2'>
                                <Item
                                    label="Name"
                                    name="name"
                                    rules={[{ required: true, message: 'Please select a Name' }]}
                                >
                                    <Input/>
                                </Item>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={12} className='p-2'>
                                <Item
                                    label="Address 1"
                                    name="address_1"
                                >
                                    <Input/>
                                </Item>
                            </Col>
                            <Col span={12} className='p-2'>
                                <Item
                                    label="Address 2"
                                    name="address_2"
                                >
                                    <Input/>
                                </Item>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={12} className='p-2'>
                                <Item
                                    label="Fax"
                                    name="fax"
                                >
                                    <Input/>
                                </Item>
                            </Col>
                            <Col span={12} className='p-2'>
                                <Item
                                    label="Telephone"
                                    name="telephone"
                                >
                                    <Input/>
                                </Item>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={12} className='p-2'>
                                <Item
                                    label="Email"
                                    name="email"
                                >
                                    <Input/>
                                </Item>
                            </Col>
                            <Col span={12} className='p-2'>
                                <Item
                                    label="Certificate Number"
                                    name="certificate_no"
                                >
                                    <Input/>
                                </Item>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={24}>
                                <Item
                                    label="Nature of Business"
                                    name="nature_of_business"
                                >
                                    <TextArea rows={5}/>
                                </Item>
                            </Col>
                        </Row>
                    </Form>
                </Modal>
            </Layout>
        </Layout>
    )
  }
  
  export default Corporate
  